import { Game } from "@blacknut/react-client-core/lib";
import { RefObject, useCallback } from "react";
import { ModalSubscription } from "../../components/Modals/ModalContext";
import { useSpatialNavigationEnabler } from "../../utils/Navigation";

const useGameSpatialNavigation = ({
  game,
  videoFullscreen,
}: {
  game?: Game;
  videoFullscreen: boolean;
  leMagModalSubscription?: RefObject<ModalSubscription | undefined | null>;
}) => {
  const shouldEnableSpatialNavigation = useCallback(() => {
    return !!game && !videoFullscreen;
  }, [game, videoFullscreen]);
  useSpatialNavigationEnabler(shouldEnableSpatialNavigation, `/${game?.id}/btns`);
};
export default useGameSpatialNavigation;
